import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import BaseSideNav from '@/components/v2/BaseSideNav.vue';
import { OVERVIEW_ROUTE, ADDONS_ROUTE, ORDERS_ROUTE, ORDERS_HISTORY_ROUTE, PRODUCTS_ROUTE, CATEGORIES_ROUTE, STORE_ROUTE, PAYMENT_ROUTE, SHIPPING_ROUTE, } from '@/helpers/constants/StoreManagerRoutes';
import { REBATES_REDEEMED_VOUCHERS_ROUTE } from '@/helpers/constants/StoreAddOnsRoutes';
let StoreManagement = class StoreManagement extends Mixins(AppDetailsMixin) {
    constructor() {
        super(...arguments);
        this.childrenMenuIcon = 'keyboard_arrow_right';
        this.toggleProductsMenu = false;
    }
    get currentRoute() {
        return this.$router.currentRoute;
    }
    get menuItems() {
        const params = {
            appUUID: this.appUuid,
        };
        let items = [];
        if (!!this.appDetails && !!this.appDetails.productComponent) {
            const { productComponent, rebatable } = this.appDetails;
            items = [
                this.productMenu(productComponent.uuid),
                ...this.buildDefaultMenu({ ...params, componentUUID: productComponent.uuid }),
            ];
            if (rebatable) {
                items.push(this.rebatesMenuItem);
            }
        }
        const menuItems = items.length >= 1 ? items : this.buildDefaultMenu(params);
        return [
            {
                icon_path: require('./assets/overview-orange.svg'),
                text: OVERVIEW_ROUTE.title,
                path: {
                    name: OVERVIEW_ROUTE.name,
                    params,
                },
                exact: false,
            },
            {
                icon_path: require('./assets/store.svg'),
                text: STORE_ROUTE.title,
                path: {
                    name: STORE_ROUTE.name,
                    params,
                },
                exact: false,
            },
            ...menuItems,
        ];
    }
    /**
     * Default Menu Items Builder
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.6
     *
     * @returns {Menu[]} list of menu items
     */
    buildDefaultMenu(params) {
        return [
            {
                icon_path: require('./assets/addon-orange.svg'),
                text: ADDONS_ROUTE.title,
                path: {
                    name: ADDONS_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/shipping-orange.svg'),
                text: SHIPPING_ROUTE.title,
                path: {
                    name: SHIPPING_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/payment-orange.svg'),
                text: PAYMENT_ROUTE.title,
                path: {
                    name: PAYMENT_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/order-orange.svg'),
                text: ORDERS_ROUTE.title,
                model: false,
                children: [
                    {
                        icon: this.childrenMenuIcon,
                        text: ORDERS_ROUTE.title,
                        path: {
                            name: ORDERS_ROUTE.name,
                            params: { status: 'pending' },
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: ORDERS_HISTORY_ROUTE.title,
                        path: {
                            name: ORDERS_HISTORY_ROUTE.name,
                            params,
                        },
                        exact: false,
                    },
                ],
            },
            {
                icon_path: require('./assets/notification.svg'),
                text: 'Notification Manager',
                path: {
                    name: 'store-manager-notifications',
                    params,
                },
                exact: false,
            },
        ];
    }
    productMenu(productUuid) {
        const params = {
            appUUID: this.appUuid,
            componentUUID: productUuid,
        };
        return {
            icon_path: require('./assets/products-orange.svg'),
            text: PRODUCTS_ROUTE.title,
            model: false,
            children: [
                {
                    icon: this.childrenMenuIcon,
                    text: 'All Products',
                    path: {
                        name: PRODUCTS_ROUTE.name,
                        params,
                    },
                    exact: false,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: CATEGORIES_ROUTE.title,
                    path: {
                        name: CATEGORIES_ROUTE.name,
                        params,
                    },
                    exact: false,
                },
            ],
        };
    }
    get rebatesMenuItem() {
        const params = { appUUID: this.appUuid };
        return {
            icon_path: require('./assets/rebates-orange.svg'),
            text: REBATES_REDEEMED_VOUCHERS_ROUTE.title,
            path: {
                name: 'redeemed-vouchers',
                params,
            },
            exact: true,
        };
    }
};
StoreManagement = __decorate([
    Component({
        components: { BaseSideNav },
    })
], StoreManagement);
export default StoreManagement;
